<template>
  <div class="storeWrap">
    <HeadBack title="店铺详情" />
    <div class="firstStore">
      <div class="storeInfo">
        <div class="topStore">
          <img :src="storeInfo.logoUrl" alt="" class="imgStore">
          <div class="rightStore">
            <div class="flexSty">
              <p class="name">{{ storeInfo.storeName }}</p>
              <p class="constrc" @click="showPhone(storeInfo.note)">联系商家</p>
            </div>
            <div class="flexBtSty">
              <div class="storeDesc">
                {{ storeInfo.detail }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="storeDetail">
      <div class="sortSearch">
        <div class="sortWrap">
          <p :class="(activeTab=='descNew'||activeTab=='ascNew')?'activeSort':''" @click="priceSort('new')">最新
            <i class="el-icon-caret-top" :class="activeTab=='ascNew'?'activeSort':''"></i>
            <i class="el-icon-caret-bottom" :class="activeTab=='descNew'?'activeSort':''"></i>
          </p>
          <p :class="!(activeTab=='descNew'||activeTab=='ascNew')?'activeSort':''" @click="priceSort('price')">价格
            <i class="el-icon-caret-top" :class="activeTab=='ascPrice'?'activeSort':''"></i>
            <i class="el-icon-caret-bottom" :class="activeTab=='descPrice'?'activeSort':''"></i>
          </p>
        </div>
        <div class="searchWrap">
          <el-input v-model="searchInfo" placeholder="搜索你想要找的商品" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="searchStore"></el-button>
          </el-input>
        </div>
      </div>
      <div class="goodList">
        <div v-for="(items,indexs) of goodList" :key="indexs" class="goodStys" :class="{'maTop':indexs>=6}">
          <div class="goodItem" @click="goGoodDetail(items.commodityId)">
            <img :src="items.goodImg" alt="" class="goodImg">
            <img v-if="items.isSale" src="../../assets/images/mall/ysq.png" alt="已售罄" class="saleAll">
            <div class="name"> {{ items.commodityName }}</div>
            <p class="marketPWrap">
              <span>¥{{ items.marketPrice }}</span>
            </p>
            <p class="priceWrap">
              <span v-if="items.payType==6"><i class="price">{{ items.price }}</i><i class="newIsty">{{ items.symbolNameCh }}</i></span>
              <span v-else><i class="yutil">¥</i><i class="price">{{ items.price }}</i></span>
            </p>
          </div>
        </div>
        <!-- <div v-for="i of Math.ceil(goodList.length/6)" :key="i" class="twoStyleRow" :style="{'top': (i)*280 + ((i-1)*30) + 'px'}">
          <div class="bottomLine">
          </div>
        </div> -->
      </div>
    </div>
    <el-row v-if="pageData.total">
      <el-col :span="24" class="paginateWrap">
        <el-pagination
          popper-class="_popStyle"
          :current-page="pageData.currentPage"
          :page-sizes="pageData.pageSizes"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pageData.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </el-col>
    </el-row>
    <contractInfo ref="contrantRef" />
  </div>
</template>
<script>
/* global protocol http */
import HeadBack from '@/components/base/header/HeadBack.vue'
import contractInfo from '@/components/contractInfo/contractInfo.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    HeadBack,
    contractInfo
  },
  data() {
    return {
      activeTab: 'ascNew',
      storeInfo: {
        logoUrl: '',
        storeName: null,
        note: null,
        detail: null,
        storeId: null
      },
      goodList: [],
      sort: [{
        'direction': 'ASC',
        'property': 'sortId'
      }],
      // 分页相关
      pageData: {
        total: null,
        pageSizes: [12, 24, 36, 48],
        pageSize: 12,
        currentPage: 1
      },
      isNetWrong: false,
      searchInfo: null,
      userPrice: 'price'
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter'])

  },
  mounted() {
    this.storeInfo = JSON.parse(sessionStorage.getItem('storeInfo'))
    this.getCommoditye()
  },
  methods: {
    showPhone(phones) {
      this.$refs.contrantRef.openDialog(phones)
    },
    searchStore() {
      this.pageData.currentPage = 1
      this.goodList = []
      this.getCommoditye()
    },
    getCommoditye() {
      protocol.param_findCommodity.param.firmTopId = null
      protocol.param_findCommodity.param.page = this.pageData.currentPage - 1
      protocol.param_findCommodity.param.size = this.pageData.pageSize
      protocol.param_findCommodity.param.storeId = this.storeInfo.storeId
      // protocol.param_findCommodity.param.mallFlag = 'I'
      protocol.param_findCommodity.param.mallFlag = null
      protocol.param_findCommodity.param.commodityId = null
      protocol.param_findCommodity.param.commodityName = this.searchInfo ? this.searchInfo : null
      protocol.param_findCommodity.param.sort = this.sort
      http.postFrontMall(protocol.param_findCommodity).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          this.pageData.total = value.totalElements
          this.isNetWrong = false
          const contentList = []
          for (let j = 0; j < value.content.length; j++) {
            const item = value.content[j]
            const newObj = {
              commodityName: item.commodityName,
              commodityId: item.commodityId,
              price: item.price,
              marketPrice: item.skus[0].skuPrice,
              goodInfo: item.skus[0],
              goodImg: '',
              actSalesNumber: item.salesNumber,
              unitQuantifier: item.unitQuantifier,
              payType: item.pays[0].payType,
              symbolNameCh: item.pays[0].symbolNameCh,
              sortId: item.sortId,
              isSale: Number(item.reserve) <= 0
            }
            for (let m = 0; m < item.imgs.length; m++) {
              if (item.imgs[m].isMain === '1') {
                newObj.goodImg = item.imgs[m].img
              }
            }
            contentList.push(newObj)
          }
          this.goodList = contentList
        } else {
          this.$message({ message: message })
          this.isNetWrong = true
          this.goodList = []
        }
      }).catch(() => {
      })
    },
    priceSort(type) {
      if (type === 'new') {
        if (this.activeTab === 'ascNew') {
          this.activeTab = 'descNew'
          this.sort = [{
            'direction': 'DESC',
            'property': 'sortId'
          }]
        } else {
          this.activeTab = 'ascNew'
          this.sort = [{
            'direction': 'ASC',
            'property': 'sortId'
          }]
        }
      } else {
        if (this.activeTab === 'ascPrice') {
          this.activeTab = 'descPrice'
          this.sort = [{
            'direction': 'DESC',
            'property': this.userPrice
          }]
        } else {
          this.activeTab = 'ascPrice'
          this.sort = [{
            'direction': 'ASC',
            'property': this.userPrice
          }]
        }
      }
      this.pageData.currentPage = 1
      this.goodList = []
      this.getCommoditye()
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.getCommoditye()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.getCommoditye()
    },
    goGoodDetail(id) {
      this.$router.push({
        name: 'mallDetail',
        params: {
          commodityId: id
        }
      })
    }

  }
}
</script>
    <style lang="scss" scoped>
    .storeWrap{
      background: #292C3A;
      min-height: 100%;
    }
      .firstStore{
        height: 87px;
        display: flex;
        align-items: center;
          background: #3B3E4E;
          .storeInfo{
              width:1200px;
              margin: 0 auto;
        .topStore{
          display: flex;
          align-items: center;
          .imgStore{
            width: 60px;
            height: 60px;
            border-radius: 43px 43px 43px 43px;
            margin-right: 13px;
          }
          .rightStore{
            width:calc(100% - 73px);
          }
          .flexSty{
            display: flex;
            align-items: center;
          }
          .flexBtSty{
            margin-top:10px;
          }
          .name{
            font-size: 20px;
            font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
            font-weight: 500;
            color: #C99F62;
            line-height: 23px;
          }
          .constrc{
            margin-left:6px;
            width: 60px;
            height: 20px;
            background: #76634D;
            border-radius: 4px 4px 4px 4px;
            font-size: 12px;
            font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
            font-weight: 500;
            color: #DECAA2;
            line-height: 20px;
            text-align: center;
            cursor: pointer;
          }
        }
        .storeDesc{
          width:1000px;
          font-size: 12px;
          font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 14px;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /* 这里是超出几行省略 */
          overflow: hidden;
        }
      }
      }
    .storeDetail{
      width: 1200px;
      margin: 30px auto;
      min-height: calc(100vh - 256px);
      .sortSearch{
          display: flex;
          justify-content: space-between;
          align-items:center;
          .sortWrap{
              display: flex;
              align-items: center;
              p{
              margin-right: 40px;
              font-size: 12px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 14px;
              position: relative;
              cursor: pointer;
              }
              /deep/.el-icon-caret-top{
              position: absolute;
              font-size:12px;
              top: 0px;
              color: #FFFFFF;
              }
              /deep/.el-icon-caret-bottom{
              position: absolute;
              font-size:12px;
              bottom: -4px;
              color: #FFFFFF;
              }
              /deep/.el-icon-d-arrow-right{
              color:#fff;
          }
          .activeSort{
                color:#E4CA91;
              }
          }
          .searchWrap{
              /deep/.el-input__inner{
                  width: 240px;
                  height: 34px;
                  border-radius: 4px 0px 0px 4px;
                  background:transparent;
                  border: 1px solid #A5A6AC;
                  font-size: 14px;
                  font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
                  font-weight: 400;
                  color: #B6BDCC;
                  box-sizing: border-box;
              }
              /deep/.el-input-group__append{
                  width:60px;
                  height: 34px;
                  border:none;
                  padding: 0;
                  background: #A5A6AC;
                  color:#fff;
                  text-align: center;
                  .el-icon-search{
                  color:#fff;
                  }
              }
          }
      }
      .goodList{
        display: flex;
        flex-wrap: wrap;
        position: relative;
        .goodStys{
          margin-right: 24px;
        }
        .maTop{
          margin-top:30px;
        }
        .goodItem{
          margin-top:22px;
          width: 180px;
          height: 278px;
          background: #3B3E4E;
          padding:10px;
          box-sizing: border-box;
          cursor: pointer;
          position: relative;
        }
        .goodStys:nth-child(6n){
          margin-right: 0px;
        }
        .goodStys:nth-child(7n)::after,.goodStys:nth-child(1)::after{
          content:'';
          position: absolute;
          left:0;
            width:1200px;
            height: 2px;
            background: #3B3E4E;
            margin-top:25px;
        }
        .goodImg{
          width: 158px;
          height: 158px;
        }
        .saleAll{
          position: absolute;
          width: 52%;
          max-height: 46%;
          right: 10px;
          top: 88px;
        }
        .name{
          margin-top:10px;
          height: 32px;
          // font-size: 16px;
          // font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          // font-weight: 500;
          color: #FFFFFF;
          font-size: 14px;
          font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          font-weight: 500;
          line-height: 16px;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /* 这里是超出几行省略 */
          overflow: hidden;
        }
        .goodItem:hover {
          transform: translateY(-4px);
          transition-duration:1s;
          box-shadow: 2px 2px 2px 2px #171B2F;
          .name{
            color: #E4CA91;
          }
        }
        .marketPWrap{
          margin-top:14px;
          font-size: 14px;
          font-family: ITC Avant Garde Gothic Pro-Medium, ITC Avant Garde Gothic Pro;
          font-weight: 500;
          color: #9A9A9A;
          line-height: 19px;
          span{
            color: #9A9A9A;
            text-decoration: line-through;
          }
        }
        .priceWrap{
          margin-top:5px;
          font-size: 14px;
          font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          font-weight: 500;
          color: #B0B8DB;
          line-height: 19px;
          position: relative;
          i{
            font-style: normal;
            color:#9A9A9A;
          }
        .utils{
          margin-left:2px;
          font-size: 12px;
          font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          font-weight: 500;
          color: #FFFFFF;
        }
        .yutil{
          font-size: 14px;
          font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
          font-weight: normal;
          color: #E4CA91;
        }
        .price{
          font-size: 20px;
          font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
          font-weight: normal;
          color: #E4CA91;
        }
        .newIsty{
          position: absolute;
          right:-10px;
          padding:0 6px 0 24px;
          height: 18px;
          background:linear-gradient(65deg, transparent 18px,#E4CA91 0);
          font-size: 12px;
          font-family: "Alibaba PuHuiTi-Medium, Alibaba PuHuiTi";
          font-weight: 500;
          color: #382804;
          line-height: 18px;
        }
        }
        .twoStyleRow{
          width: 100%;
          height:30px;
          position: absolute;
          top: 280px;
          .bottomLine{
            width:100%;
            height: 2px;
            background: #3B3E4E;
            margin-top:28px;
          }
        }
      }
    }
    </style>

